import { AlertContext } from "contexts/AlertContext"
import useTranslation from "hooks/useTranslation"
import { useAuth } from "contexts/AuthContext"
import { useContext } from "react"
import { DELETE, POST } from "api/request"
import * as url from 'api/urls'
import Modal from "./Modal"

interface SaveProfileModalProps {
  data: board.BoardResponse | null | undefined
  type: string
  onClose: () => void
  setModal: (modaltype: string) => void
  onReload: () => void
}

const SaveProfileModal: React.FC<SaveProfileModalProps> = ({ data, type, onClose, setModal, onReload }) => {
  const { t } = useTranslation('saveprofilemodal')
  const { isAuth } = useAuth()
  const { showAlert } = useContext(AlertContext)

  if (!isAuth) setModal('loginRequired')

  const handleSaveProfile = async () => {
    try {
      const response = await (type === 'save'
        ? POST(url.saveBoard(data?.data.id))
        : DELETE(url.saveBoard(data?.data.id)))

      if (response.ok) {
        onReload()
        onClose()
        showAlert(type === 'save' ? 'Zapisano profil!' : 'Usuniętno z zapisanych', 'success')
      } else {
        showAlert('Wystąpił błąd', 'error')
      }
    } catch (err) {
      console.error(err)
    }
  }


  return (
    <Modal
      onClose={onClose}
      title={type === 'save' ? t('save_profile') : t('delete_from_saved')}
      primaryButton={type === 'save' ? t('save_profile') : t('delete_from_saved')}
      primaryButtonAction={() => handleSaveProfile()}
      secondaryButton={t('cancel')}
      secondaryButtonAction={'close'}
      icon={type === 'save' ? 'save' : 'saved'}
    >

      <div className="center">
        {type === 'save'
          ? t('click_save')
          : t('click_delete')
        }

      </div>
    </Modal>)
}

export default SaveProfileModal